<template>
  <!-- Full-screen black backdrop; the cropper leaves the bottom clear for the ✕/✓ bar -->
  <div
    class="fixed top-0 left-0 right-0 bottom-0 bg-black flex flex-col z-50 font-aktiv-grotesk-medium w-full"
  >
    <Cropper
      ref="cropper"
      class="upload-example-cropper h-[calc(100%-69px)]"
      :src="image"
      :stencil-component="$options.components.CircleStencil"
    />
    <div
      class="fixed bottom-0 left-0 right-0 mb-[70px] flex flex-row bg-black justify-between items-center px-8"
      :class="{ '!mb-[87px]': isIos }"
    >
      <div
        class="w-[52px] h-[52px] rounded-full bg-red-500 flex items-center justify-center cursor-pointer"
        @click="closeImagePreview()"
      >
        <img class="w-[36px] h-[36px]" src="../../../public/assets/icons/cross-white.svg" />
      </div>
      <div
        class="w-[52px] h-[52px] flex items-center justify-center"
        :class="isCropping ? 'pointer-events-none' : 'cursor-pointer'"
        @click="cropImage()"
      >
        <img
          v-if="!isCropping"
          class="w-[52px] h-[52px]"
          src="../../../public/assets/icons/blue-tick.svg"
        />
        <div
          v-else
          class="w-[36px] h-[36px] rounded-full border-4 border-white border-t-transparent animate-spin"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Cropper, CircleStencil } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import { mapState } from 'vuex';
import platformMixin from '@/mixins/platformMixin';

export default {
  mixins: [platformMixin],
  // eslint-disable-next-line vue/no-unused-components
  components: { Cropper, CircleStencil },
  data() {
    return {
      image: '',
      isCropping: false,
    };
  },
  computed: {
    ...mapState('social', ['selectedPicture']),
  },
  mounted() {
    this.image = this.selectedPicture;
  },
  methods: {
    closeImagePreview() {
      this.$router.push('/profile/edit');
    },
    async cropImage() {
      // Ignore repeat taps while a crop is already encoding.
      if (this.isCropping) return;
      this.isCropping = true;

      // Encoding a full-resolution photo (toDataURL + toBlob) blocks the main
      // thread for several seconds. Yield first so the spinner actually paints
      // before the freeze; its CSS animation keeps running on the compositor
      // thread even while JS is busy.
      await this.$nextTick();
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));

      try {
        const result = this.$refs.cropper.getResult();
        const imgObj = result.canvas.toDataURL('image/jpeg');
        this.$store.commit('social/setForm64Picture', imgObj);

        // canvas.toBlob is reliable in WKWebView, unlike fetch() on data: URLs,
        // which silently failed here and left formPicture unset (pic never uploaded).
        const blob = await new Promise(resolve => result.canvas.toBlob(resolve, 'image/jpeg'));
        if (!blob) throw new Error('canvas.toBlob returned null');
        this.$store.commit('social/setFormPicture', blob);
      } catch (e) {
        console.error('[profile-pic] crop failed:', e?.message || e);
      } finally {
        this.isCropping = false;
      }
      this.$router.push('/profile/edit');
    },
  },
};
</script>
<style>
.upload-example-cropper {
  width: 100%;
  background: #000;
}
/* vue-advanced-cropper paints its own backdrop; keep it black to match the overlay */
.upload-example-cropper .vue-advanced-cropper__background,
.upload-example-cropper .vue-advanced-cropper__foreground {
  background: #000;
}
</style>
